import { Reducer } from "redux";
import createRootReducer, { SdkStoreStates } from "./reducers";
import {
  SdkConfigureStore as BaseConfigureStore,
  ConfigureStoreType as BaseConfigureStoreType,
  SdkPersistConfig,
  SdkStore,
  configureStore as baseConfigureStore,
} from "../store";

export type ConfigureStoreType<S extends SdkStoreStates = SdkStoreStates> = BaseConfigureStoreType<S>;

export interface SdkConfigureStore extends Omit<BaseConfigureStore, "appReducers"> {
  appReducers?: Record<string, Reducer>;
}

export function configureStore<S extends SdkStoreStates = SdkStoreStates>(
  config: SdkConfigureStore = {}
): ConfigureStoreType<S> {
  const appReducers = createRootReducer<S>(config.appReducers);
  return baseConfigureStore({ ...config, appReducers });
}

export { SdkPersistConfig, SdkStore };
